// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {deleteFile as deleteFileRepo, getFiles as getFileRepo} from '../../shared/repositories';
import actions from '../../actions-list';

export const deleteFileFromStatusChangeRequest = fileToDelete =>
   async (dispatch, getState) => {

       const fileExists = getState().statusChange.statusChangeRequest.file.some(item => item.fileName === fileToDelete.fileName && item.serialNumber === fileToDelete.serialNumber);

       if (fileExists) {

           dispatch(busyCounter.increaseBusyCounter());

           try {

               await deleteFileRepo(fileToDelete);

               dispatch({
                   data: fileToDelete,
                   name: 'deleteFile',
                   type: actions.UPDATE_STATUS_CHANGE_REQUEST_OBJECT
               });

               const files = await getFileRepo(fileToDelete);

               dispatch({
                   files,
                   type: actions.UPDATE_STATUS_CHANGE_REQUEST_OBJECT_FILE_LIST
               });

           } catch (error) {

           } finally {

               dispatch(busyCounter.decreaseBusyCounter());

           }

       }

   };



// WEBPACK FOOTER //
// ./src/product/status-change-request/action-creators/delete-file.js